import React, { useState, useCallback, useRef } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import ProstateForm from "./ProstateForm";
import ProstateSubForm from "./ProstateSubForm";
import ProstateFormResult from "./ProstateFormResult";
import ProstateSubFormResult from "./ProstateSubFormResult";
import ProstateResult from "./ProstateResult";
import {
  updateProstate,
  getProstateTotal,
} from "../../services/actions/_actions";
import {
  ageProstate,
  que1CulPro,
  paProstateCul,
  hpynProstateCul,
  smokingProstateCul,
  bmiProstate,
  year9CaseProstate20220511,
  newProstateAgeChecker,
  newDefaultProstateAgeChecker,
} from "../../utils/calculate";
import axios from "axios";

const ProstateCancerComp = ({ prostateRe, total, updateData, getTotal }) => {
  const history = useHistory();
  const [page, setPage] = useState(0);
  const [score, setScore] = useState(prostateRe);
  const inputElAge = useRef(null); // 연령
  const inputElCm = useRef(null); // 신장
  const inputElKg = useRef(null); // 체중
  const inputElGap = useRef(null); // 갑

  const handleSetScore = useCallback(
    (text, result) => {
      setScore({
        ...score,
        [text]: result,
      });
    },
    [score]
  );

  const handleChange = (num) => {
    setPage(num);
  };

  const handleChangePage = useCallback(
    (num) => {
      updateData(score);
      setPage(num);
    },
    [score, updateData]
  );
  const handleMainLink = useCallback(() => {
    history.push("/");
  }, [history]);

  const handleSexChange = useCallback(
    (bool = true) => {
      handleSetScore("sex", bool);
    },
    [handleSetScore]
  );

  // 체중 계산
  const handleKGChange = useCallback(
    (caseView = "kg", e) => {
      if (e.target.value === "") {
        handleSetScore(caseView, "");
      }
      let val = parseInt(e.target.value);
      if (0 <= val && val <= 120) {
        handleSetScore(caseView, val);
      }
    },
    [handleSetScore]
  );

  // 신장 계산
  const handleCmChange = useCallback(
    (caseView = "cm", e) => {
      if (e.target.value === "") {
        handleSetScore(caseView, "");
      }
      let val = parseInt(e.target.value);
      if (0 <= val && val <= 250) {
        handleSetScore(caseView, val);
      }
    },
    [handleSetScore]
  );

  // 나이 계산
  const handleAgeChange = useCallback(
    (caseView = "age", e) => {
      if (e.target.value === "") {
        handleSetScore(caseView, "");
      }
      let val = parseInt(e.target.value);
      if (0 <= val && val <= 120) {
        handleSetScore(caseView, val);
      }
    },
    [handleSetScore]
  );

  // 흡연 연도 계산
  const handleYearChange = useCallback(
    (caseView = "gapYear", e) => {
      if (e.target.value === "") {
        handleSetScore(caseView, "");
      }
      let val = parseInt(e.target.value);
      if (0 <= val && val <= 120) {
        handleSetScore(caseView, val);
      }
    },
    [handleSetScore]
  );

  //흡연 갑 수 계산
  const handleRangeChange = useCallback(
    (e, data) => {
      setScore({
        ...score,
        smokingGap: data,
      });
    },
    [score]
  );

  // 다음으로 페이지 이동
  const handlePageMove = useCallback(() => {
    // if( score.kg)
    if (score.cm === "" || !score.cm) {
      alert("신장을 입력해 주세요.");
      inputElCm.current.focus();
      return false;
    }
    if (isNaN(score.cm) || score.cm < 100 || score.cm > 230) {
      alert("신장을 확인해 주세요.");
      inputElCm.current.focus();
      return false;
    }
    if (score.age === "" || !score.age) {
      alert("연령을 입력해 주세요.");
      inputElAge.current.focus();
      return false;
    }
    if (isNaN(score.age)) {
      alert("연령을 확인해 주세요.");
      inputElAge.current.focus();
      return false;
    }
    if (score.age < 40 || score.age > 90) {
      alert("40세이상 120세미만만 위험도 계산이 가능합니다.");
      inputElAge.current.focus();
      return false;
    }
    if (score.kg === "" || !score.kg) {
      alert("체중을 입력해 주세요.");
      inputElKg.current.focus();
      return false;
    }
    if (isNaN(score.kg)) {
      alert("체중을 확인해주세요.");
      inputElKg.current.focus();
      return false;
    }
    if (score.kg < 30 || score.kg > 150) {
      inputElKg.current.focus();
      alert("체중을 확인해 주세요.");
      return false;
    }
    handleChangePage(1);
  }, [handleChangePage, score.age, score.cm, score.kg]);

  // 다음으로 페이지 이동
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handlePageMoveEnd = () => {
    // if( score.kg)
    if (score.smoking) {
      if (score.gapYear === "" || !score.gapYear || score.gapYear === 0) {
        alert("흡연 년도를 입력해주세요 .");
        inputElGap.current.focus();
        return false;
      }
      if (score.gapYear < 0 || score.gapYear > 120) {
        alert("흡연 년도를 입력해주세요 .");
        inputElGap.current.focus();
        return false;
      }
      if (score.smokingGap === 0) {
        alert("하루 평균 몇갑을 입력해 주세요.");
        return false;
      }
    }
    handleChangePage(2);
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleTotal = async () => {
    const res = await axios.get("https://geolocation-db.com/json/");
    const total =
      ageProstate(prostateRe.age) +
      bmiProstate(prostateRe.kg, prostateRe.cm) +
      que1CulPro(prostateRe.dmyn) +
      hpynProstateCul(prostateRe.hpyn) +
      paProstateCul(prostateRe.pa) +
      smokingProstateCul(
        prostateRe.smoking,
        prostateRe.gapYear,
        prostateRe.smokingGap
      );
    const meyper = year9CaseProstate20220511(total);
    const meAgeAroundPer = newProstateAgeChecker(
      prostateRe.age,
      prostateRe.sex
    );
    const meAgedefaultAroundPer = newDefaultProstateAgeChecker(
      prostateRe.age,
      prostateRe.sex
    );
    const perCal = {
      case9year: meyper,
      caseAge: meAgeAroundPer,
      casedefaultAge: meAgedefaultAroundPer,
      ip: res.data.IPv4,
    };

    getTotal(total, prostateRe, perCal);

    handleChange(3);
  };

  const prostateFormPage = useCallback(() => {
    if (page === 0) {
      return (
        <>
          <ProstateForm
            score={score}
            onSexChange={handleSexChange}
            onKGChange={handleKGChange}
            onAgeChange={handleAgeChange}
            onCmChange={handleCmChange}
            onPageMove={handlePageMove}
            inputElAge={inputElAge}
            inputElCm={inputElCm}
            inputElKg={inputElKg}
          />
        </>
      );
    } else if (page === 1) {
      return (
        <ProstateSubForm
          score={score}
          onPageChange={handleChange}
          onChange={handleSetScore}
          onYearChang={handleYearChange}
          onRangeChange={handleRangeChange}
          onPageMove={handlePageMoveEnd}
          inputElGap={inputElGap}
        />
      );
    } else if (page === 2) {
      return (
        <ProstateFormResult
          onPageChange={handleChange}
          onLinkHome={handleMainLink}
          score={score}
          onChange={handleSetScore}
          data={prostateRe}
          onTotal={handleTotal}
          // onRangeChange={handleRangeChange}
        />
      );
    } else if (page === 3) {
      return (
        <ProstateSubFormResult
          onPageChange={handleChange}
          onLinkHome={handleMainLink}
          score={score}
          onChange={handleSetScore}
          total={total}
          data={prostateRe}
        />
      );
    } else if (page === 4) {
      return (
        <ProstateResult
          onPageChange={handleChange}
          onLinkHome={handleMainLink}
          score={score}
          onChange={handleSetScore}
        />
      );
    }
  }, [
    handleAgeChange,
    handleCmChange,
    handleKGChange,
    handleMainLink,
    handlePageMove,
    handlePageMoveEnd,
    handleRangeChange,
    handleSetScore,
    handleSexChange,
    handleYearChange,
    handleTotal,
    prostateRe,
    page,
    score,
    total,
  ]);
  return <>{prostateFormPage()}</>;
};

const mapStateToProps = (state) => {
  return {
    prostateRe: state.prostateRe.prostateData,
    total: state.prostateRe.total,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateData: (datas) => {
      dispatch(updateProstate({ datas }));
    },
    getTotal: (total, prostateRe, perCal) => {
      dispatch(getProstateTotal(total, prostateRe, perCal));
    },
  };
};

export default connect(
  // 스토어와 연결
  mapStateToProps,
  mapDispatchToProps
)(ProstateCancerComp);
